/* Cotton Culture V34: size-to-cart on product listing cards.
   One delegated listener handles initial cards, filtering and infinite scroll. */
(function () {
  'use strict';
  if (window.__ccCardPurchaseBound) return;
  window.__ccCardPurchaseBound = true;

  function cardFor(node) { return node && node.closest('[data-cc-card-purchase]'); }
  function notice(card, message, isError) {
    var live = card && card.querySelector('[data-cc-card-status]');
    if (!live) return;
    live.textContent = message;
    live.classList.toggle('is-error', !!isError);
  }
  function rootUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '/') + path.replace(/^\//, '');
  }
  function selectSize(button) {
    var card = cardFor(button);
    if (!card || card.dataset.ccBusy === 'true') return;
    card.querySelectorAll('[data-cc-size]').forEach(function (size) {
      var selected = size === button;
      size.classList.toggle('is-selected', selected);
      size.setAttribute('aria-pressed', String(selected));
    });
    var add = card.querySelector('[data-cc-card-add]');
    if (add) add.dataset.variantId = button.dataset.variantId || '';
    notice(card, '');
  }
  async function addToCart(button) {
    var card = cardFor(button);
    if (!card || card.dataset.ccBusy === 'true' || button.disabled) return;
    var variantId = button.dataset.variantId;
    if (!variantId) {
      notice(card, 'Please select a size first.', true);
      var size = card.querySelector('[data-cc-size]');
      if (size) size.focus();
      return;
    }
    card.dataset.ccBusy = 'true';
    button.disabled = true;
    var label = button.textContent;
    button.textContent = 'Adding…';
    notice(card, '');
    try {
      var response = await fetch(rootUrl('/cart/add.js'), {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      });
      var result = await response.json().catch(function () { return {}; });
      if (!response.ok) throw new Error(result.description || result.message || 'Could not add this size to your cart.');
      button.textContent = 'Added ✓';
      notice(card, 'Added to your cart.');
      if (window.theme && window.theme.settings && window.theme.settings.cartType === 'page') {
        window.location.assign(rootUrl('/cart'));
        return;
      }
      // The Impulse cart drawer already listens for these events.
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:open'));
    } catch (error) {
      button.textContent = 'Try again';
      notice(card, error.message || 'Unable to add to cart. Please try again.', true);
    } finally {
      card.dataset.ccBusy = 'false';
      // Keep feedback visible for screen readers; restore action after a delay.
      window.setTimeout(function () {
        if (!button.isConnected) return;
        button.disabled = false;
        button.textContent = label;
      }, 1400);
    }
  }
  // Capture the interaction before any theme-level card or link handlers.
  // Impulse uses a full-card link overlay; CSS lifts these real buttons above
  // that overlay, and the capture handler blocks older product-navigation code.
  // Delegation also works after AJAX filters and infinite-scroll replacements.
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var size = target.closest('[data-cc-size]');
    if (size && cardFor(size)) {
      event.preventDefault();
      event.stopPropagation();
      selectSize(size);
      return;
    }
    var add = target.closest('[data-cc-card-add]');
    if (add && cardFor(add)) {
      event.preventDefault();
      event.stopPropagation();
      addToCart(add);
    }
  }, true);
})();
